<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; form.helpId = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Bantuan
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Judul"
                  color="#ff618a"
                  v-model="form.helpTitle"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Sub Judul" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Sub Judul"
                  color="#ff618a"
                  v-model="form.helpSubTitle"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.helpStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'FAQ', 
                      value: 'faq'
                    },
                    {
                      title: 'Help', 
                      value: 'help'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Type"
                  v-model="form.helpType"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <p class="mb-1">Deskripsi</p>
              <quill-editor ref="myTextEditor" v-model="form.helpDesc" :options="option"></quill-editor>
              <p class="caption mt-1 mb-1 red--text" v-show="error.helpDesc">{{ error.helpDesc }}</p>
              <div class="mt-3 mb-3">
                <p class="mb-1">Gambar</p>
                <form class="mt-1">
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar" color="grey darken-3" large>mdi-camera</v-icon>
                          <img v-else :src="form.helpImage" :alt="form.helpImage" />
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.helpImage">
                  {{ error.helpImage }}
                </p>
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn
                  small
                  rounded
                  width="100"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.form || selectedPage === ''"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  small
                  width="100"
                  elevation="0"
                  :disabled="process.form"
                  class="text-capitalize"
                  @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <v-img :src="help.imageUrlIcon" width="100" height="100" class="mx-auto br-20"></v-img>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              {{help.title}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Sub Judul
              </p>
              {{help.subtitle}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{help.status}}
            </v-list-item-title>
             <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Type
              </p>
              {{help.type}}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mt-2 mb-1">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
              v-html="help.description">
            </p>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="reset(undefined, 'mobile'); selectedPage = 'create'">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari bantuan . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();showPage = false"
            v-on:keyup.enter="fetch(); showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#ff618a' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :light="showPage"
            :disabled="process.form"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">Tambah Bantuan</span>
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>
        <div class="my-5">
          <div class="title text--secondary">Data Bantuan</div>
          <div class="caption text--secondary">{{pagination.totalData}} Bantuan Ditemukan</div>

          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index" >
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar tile @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer" style="box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                  <v-img :src="l.imageUrlIcon" style="border-radius: 5px;"></v-img>
                </v-list-item-avatar>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                    {{l.title}}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="$vuetify.breakpoint.name !== 'xs'"
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    {{l.subtitle}} | {{ l.status }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="ml-3 text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      :disabled="process.form"
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                      @click="selectedPage = 'update'">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      color="red"
                      elevation="0"
                      :disabled="process.form"
                      class="text-capitalize white--text ma-1"
                      @click="form.helpId = l.id; dialog.delete = true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data FAQ"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#ff618a"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Bantuan
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Judul"
                  color="#ff618a"
                  v-model="form.helpTitle"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Sub Judul" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Sub Judul"
                  color="#ff618a"
                  v-model="form.helpSubTitle"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.helpStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
                <v-select
                  :items="[
                    {
                      title: 'FAQ', 
                      value: 'faq'
                    },
                    {
                      title: 'Help', 
                      value: 'help'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Type"
                  v-model="form.helpType"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <p class="mb-1">Deskripsi</p>
              <quill-editor ref="myTextEditor" v-model="form.helpDesc" :options="option"></quill-editor>
              <p class="caption mt-1 mb-1 red--text" v-show="error.helpDesc">{{ error.helpDesc }}</p>
              <div class="mt-3 mb-3">
                <p class="mb-1">Gambar</p>
                <form class="mt-1">
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                          <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;"
                            >
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                            </v-progress-linear>
                          </div>
                          <img v-if="avatar && !addImage" 
                          :src="form.helpImage" 
                          :alt="form.helpImage" 
                          width="200"
                          height="200"/>
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.helpImage">
                  {{ error.helpImage }}
                </p>
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
              </div>
              <v-card-actions class="mt-3">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  light
                  dense
                  width="200"
                  color="#ff618a"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <v-img :src="help.imageUrlIcon" width="100" height="100" class="mx-auto br-20"></v-img>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              {{help.title}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Sub Judul
              </p>
              {{help.subtitle}}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{help.status}}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mt-2 mb-1">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
              v-html="help.description">
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import ImageInput from "../../../../components/ImageInput.vue";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog: {
          delete: false,
          form: false
        },
        avatar:"",
        showPage: false,
        selectedPage: "",
        filter: {
          title: ""
        },
        list: [],
        help: {},
        pagination: {},
        page: 1,
        addImage:"",
        form: {
          helpId: "",
          helpImage: "",
          helpTitle: "",
          helpSubTitle: "",
          helpDesc: "",
          helpStatus: ""
        },
        error: {
          helpDesc: "",
          helpImage: ""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.helpImage = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add
          this.error.helpImage = ''
        },
        deep: true
      }
    },
    components: {
      ImageInput,
      Empty
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/internal/help/list`, {
            params: {
              pagenum: p,
              limit: 10,
              search:this.filter.title ? 'title:'+this.filter.title : '',
            }
          })
        .then(response => {
          let res = response.data;
          if (res.code === 200) {
            this.process.run = false;
            this.list = res.data;
            this.pagination = res.pagination;
          }
        });
      },
      toDetail(item, status) {
        this.help = item
        this.selectedPage = "detail"
        this.help.description = this.help.description.replace(/&lt;/g, "<")
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.imageUrlIcon
        } : ''
        this.addImage = item !== undefined ? false : ""
        this.form = {
          helpId: item !== undefined ? item.id : "",
          helpImage : item !== undefined ? item.imageUrlIcon : "",
          helpTitle: item !== undefined ? item.title : "",
          helpSubTitle: item !== undefined ? item.subtitle : "",
          helpDesc : item !== undefined ? item.description.replace(/&lt;/g, "<") : "",
          helpStatus: item !== undefined ? item.status : "",
          helpType:  item !== undefined ? item.type : ""
        }

        this.selectedPage = ''
        this.process.form = false

        this.error = {
          helpDesc: "",
          helpImage: ""
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false
        this.response = ''
      },
      validation() {
        var error = this.error,
          valid = true;

        if (this.form.helpDesc === "") {
          error.helpDesc = "Kolom tidak boleh kosong";
          valid = false;
        } else {
          error.helpDesc = "";
        }

        if (this.form.helpImage === "") {
          error.helpImage = "Gambar tidak boleh kosong";
          valid = false;
        } else {
          error.helpImage = "";
        }
        return valid;
      },
      async save() {
        this.response = "";
        const valids = this.validation();
        const isValid = await this.$refs.observer.validate();
        if (isValid && valids) {
          if (this.form.helpId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/help/create`, {
          data: {
            subtitle: this.form.helpSubTitle,
            imageUrlIcon: this.form.helpImage,
            description: this.form.helpDesc,
            title: this.form.helpTitle,
            status: this.form.helpStatus,
            type: this.form.helpType
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/help/update/${this.form.helpId}`, {
          data: {
            id: this.form.helpId,
            subtitle: this.form.helpSubTitle,
            imageUrlIcon: this.form.helpImage,
            description: this.form.helpDesc,
            title: this.form.helpTitle,
            status: this.form.helpStatus,
            type: this.form.helpType
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes() {
        this.process.form = true;
        await destroy(`api/internal/help/delete/${this.form.helpId}`)
        .then((response) => {
          let res = response.data;
          if (res.code === 201) {
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.form.helpId = ''
            this.fetch()
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  };
</script>

<style scoped>
.br-20 {
  border-radius: 20px;
}
</style>

